__turbopack_context__.v({
  "reviewsSearchPlace": "reviews-search-place-module-scss-module__q9nZqG__reviewsSearchPlace",
  "reviewsSearchPlace_listingTypes": "reviews-search-place-module-scss-module__q9nZqG__reviewsSearchPlace_listingTypes",
  "reviewsSearchPlace_searchBox": "reviews-search-place-module-scss-module__q9nZqG__reviewsSearchPlace_searchBox",
  "reviewsSearchPlace_title": "reviews-search-place-module-scss-module__q9nZqG__reviewsSearchPlace_title",
});
